import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects'

import { IError, ILogin, ISendLogin, LoginGeneratorYield, SEND_LOGIN, SEND_LOGIN_FAIL, SEND_LOGIN_SUCCESS } from '.'
import { ApiResponse } from '../../interfaces'
import sendLoginService from '../../services/sendLogin'
import { SEND_TO } from '../sendTo'

function* sendLogin({
  payload: { userId, type, socialToken, username, password, recaptchaCode, middleware },
}: ISendLogin): Generator<LoginGeneratorYield, void, ApiResponse<ILogin | IError>> {
  const { success, data, status } = yield call(
    sendLoginService,
    type,
    socialToken,
    username,
    password,
    recaptchaCode,
    middleware
  )

  if (success) {
    const response = data as ILogin

    yield put({
      type: SEND_LOGIN_SUCCESS,
      payload: response,
    })

    yield put({
      type: SEND_TO,
      payload: { userId, ...response },
    })
  } else {
    const { message, details } = data as IError

    yield put({
      type: SEND_LOGIN_FAIL,
      payload: {
        message,
        details,
        status,
      },
    })
  }
}

export function* loginSaga(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(SEND_LOGIN, sendLogin)
}
